import React, { Component } from 'react';
import { getProducts, getCartProducts, addProduct, removeProduct, updateProductQuantity, fetchData, filterProducts } from '../../../repository';

class Middleware extends Component {
    constructor(props) {
        super(props);
        this.state = {            

        };

        // console.log("Cart Basket Constructor");
        // console.log(props);                        
    }

    componentDidMount() {

        // this.props.setCurrentProduct();

        // console.log("MIddleWare");
        
        // console.log(this.props);
        
        // this.set_initial_product();
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):        
        if (this.props.num_of_items !== prevProps.num_of_items) {
          this.updateProductCount(this.props.num_of_items);
        }

        
    }

    set_initial_product = () => {
        
    }

    updateProductCount() {
		console.log(this.state);
        this.props.handleCounter(this.state);        
	}

	// handleChange() {
	// 	this.setState({status: !this.state.status}, this.updateProductCount);
	// }

    render () {
        return (
            <React.Fragment>

            </React.Fragment>
        )
    }


}

export default Middleware;